module.exports = __webpack_public_path__ + "static/media/calendar.dd0a1712.svg";